
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherMasterGrid extends _Ext.GridBase<GiftVoucherMasterRow, any> {
        protected getColumnsKey() { return 'OMS.GiftVoucherMaster'; }
        protected getDialogType() { return GiftVoucherMasterDialog; }
        protected getIdProperty() { return GiftVoucherMasterRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherMasterRow.localTextPrefix; }
        protected getService() { return GiftVoucherMasterService.baseUrl; }

        constructor(container: JQuery, options) {
            super(container, options);
        }
    }
}